<template>
  <v-app id="inspire">
    <v-app-bar color="primary" app density="compact">
      <v-app-bar-nav-icon @click="drawer = !drawer" v-if="user?.email">
      </v-app-bar-nav-icon>
      <v-toolbar-title v-if="display.width.value > 570" style="flex: none">{{
        t("toolbar.app_name", { appName })
      }}</v-toolbar-title>

      <site-search v-if="currentMerchant?.uuid" class="ml-2" />

      <v-spacer></v-spacer>

      <v-progress-circular
        v-if="axiosBusy"
        indeterminate
        color="orange"
      ></v-progress-circular>

      <v-spacer></v-spacer>

      <div v-if="currentMerchant?.uuid" class="d-lg-none">
        <v-tooltip location="bottom">
          <template v-slot:activator="{ props: tooltipProps }">
            <v-btn
              icon
              size="small"
              v-bind="tooltipProps"
              :to="{
                name: 'campaigns-create',
                params: { merchantIdent: currentMerchant?.uuid },
              }"
            >
              <v-icon size="small">mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ t("toolbar.create_campaign") }}</span>
        </v-tooltip>
      </div>
      <v-btn
        v-if="currentMerchant?.uuid"
        variant="text"
        size="small"
        class="d-none d-lg-flex"
        :to="{
          name: 'campaigns-create',
          params: { merchantIdent: currentMerchant?.uuid },
        }"
      >
        <template v-slot:prepend>
          <v-icon size="small">mdi-plus</v-icon>
        </template>
        <span class="text-truncate" style="max-width: 200px">{{
          t("toolbar.create_campaign")
        }}</span>
      </v-btn>

      <v-tooltip
        location="bottom"
        v-if="
          currentMerchant?.uuid &&
          (!currentMerchant?.is_valid || currentMerchant?.errors?.length != 0)
        "
      >
        <template v-slot:activator="{ props: tooltipProps }">
          <v-btn
            icon
            size="small"
            v-bind="tooltipProps"
            :to="{
              name: 'merchant-notify',
              params: { merchantIdent: currentMerchant?.uuid },
            }"
          >
            <v-icon size="small" color="red">mdi-bell</v-icon>
          </v-btn>
        </template>
        <span>{{ t("toolbar.merchant_invalid") }}</span>
      </v-tooltip>

      <v-menu v-if="currentMerchant?.uuid">
        <template v-slot:activator="{ props: activatorProps }">
          <v-btn size="small" variant="text" v-bind="activatorProps">
            <img
              v-if="currentMerchant?.image && !currentMerchImageError"
              :src="currentMerchant?.image.src"
              width="25"
              height="25"
              class="mr-2"
              decoding="sync"
              @error="ImageError"
            />
            <v-icon v-else>mdi-image-outline</v-icon>

            <span
              class="d-none d-md-inline-flex text-truncate"
              style="max-width: 250px"
              >{{ currentMerchant?.name }}</span
            >
            <v-icon size="small">mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-subheader class="d-md-none">
            <img
              v-if="currentMerchant?.image"
              :src="currentMerchant?.image.src"
              width="25"
              height="25"
              class="mr-2"
            />
            <span class="text-truncate" style="max-width: 200px">{{
              currentMerchant?.name
            }}</span>
          </v-list-subheader>

          <v-list-item
            :to="{
              name: 'merchant-edit',
              params: { merchantIdent: currentMerchant?.uuid },
            }"
          >
            <template v-slot:prepend>
              <v-icon>mdi-pencil</v-icon>
            </template>
            <v-list-item-title>
              {{ t("toolbar.edit_merchant") }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{
              name: 'merchant-accounts',
              params: { merchantIdent: currentMerchant?.uuid },
            }"
          >
            <template v-slot:prepend>
              <v-icon>mdi-account-group</v-icon>
            </template>
            <v-list-item-title>
              {{ t("nav.merchant_accounts") }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{
              name: 'merchant-locations',
              params: { merchantIdent: currentMerchant?.uuid },
            }"
          >
            <template v-slot:prepend>
              <v-icon>mdi-map-marker</v-icon>
            </template>
            <v-list-item-title>
              {{ t("nav.merchant_locations") }}
            </v-list-item-title>
          </v-list-item>

          <v-divider />

          <v-list-item :to="{ name: 'merchant-create' }">
            <template v-slot:prepend>
              <v-icon>mdi-plus</v-icon>
            </template>
            <v-list-item-title>{{ t("toolbar.create_merchant") }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="merchantSearchType !== 'single'"
            @click.stop="showMerchantSelectModal()"
          >
            <template v-slot:prepend>
              <v-icon>mdi-sync</v-icon>
            </template>
            <v-list-item-title>{{ t("toolbar.switch_merchant") }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{
              name: 'campaigns-create',
              params: { merchantIdent: currentMerchant?.uuid },
            }"
          >
            <template v-slot:prepend>
              <v-icon>mdi-wallet-giftcard</v-icon>
            </template>
            <v-list-item-title>{{ t("toolbar.create_campaign") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu v-if="user?.email">
        <template v-slot:activator="{ props: activatorProps }">
          <v-btn variant="text" size="small" v-bind="activatorProps" class="d-none d-md-flex">
            <span class="text-truncate" style="max-width: 200px">{{
              user?.email
            }}</span>
          </v-btn>
          <v-btn icon size="x-small" color="primary" v-bind="activatorProps" class="d-md-none">
            <v-icon size="small">mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-subheader class="d-md-none">
            {{ user?.email }}
          </v-list-subheader>
          <v-list-item :to="{ name: 'oauth2-logout' }">
            <v-list-item-title>{{ t("toolbar.logout") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app>
      <v-list nav density="compact">
        <v-list-item to="/" v-if="user?.email">
          <template v-slot:prepend>
            <v-icon>mdi-home</v-icon>
          </template>
          <v-list-item-title>{{ t("nav.dashboard") }}</v-list-item-title>
        </v-list-item>

        <v-list-group
          v-for="item in menuItems"
          :value="item.key"
          :key="item.key"
        >
          <template v-slot:activator="{ props: groupProps }">
            <v-list-item v-bind="groupProps" :to="item.path_name ? { name: item.path_name, params: item.path_params } : undefined">
              <template v-slot:prepend>
                <v-icon>{{ item.icon }}</v-icon>
              </template>
              <v-list-item-title>{{
                t("nav." + item.key)
              }}</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            v-for="subItem in item.items"
            :key="subItem.key"
            :to="{ name: subItem.path_name, params: subItem.path_params }"
          >
            <v-list-item-title>{{
              t("nav." + subItem.key)
            }}</v-list-item-title>

            <template v-slot:append>
              <v-icon>{{ subItem.icon }}</v-icon>
            </template>
          </v-list-item>
        </v-list-group>

        <v-list-item :to="{ name: 'access-code-set' }" v-if="isAdmin">
          <template v-slot:prepend>
            <v-icon>mdi-lock</v-icon>
          </template>
          <v-list-item-title>{{
            t("nav.access_code_sets")
          }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isAdmin" @click="redirectAdmin()">
          <template v-slot:prepend>
            <v-icon>mdi-alien</v-icon>
          </template>
          <v-list-item-title>{{ t("nav.admin") }}</v-list-item-title>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <v-divider></v-divider>
        <v-list class="d-flex flex-column align-start">
          <v-chip v-if="isAdmin" color="red" class="ma-2">{{
            t("toolbar.is_admin")
          }}</v-chip>
          <v-chip
            v-if="isAgency"
            color="red-lighten-2"
            class="ma-2"
            >{{ t("toolbar.is_agency") }}</v-chip
          >
          <v-chip
            v-if="merchantLevel >= 1"
            color="orange"
            class="ma-2"
            >{{
              t("toolbar.merchant_level", { level: merchantLevel })
            }}</v-chip
          >
          <v-tooltip :text="buildInfo.fullDate" location="top">
            <template v-slot:activator="{ props: tooltipProps }">
              <v-chip color="grey" class="ma-2" v-bind="tooltipProps">
                {{ buildInfo.commit }} · {{ buildInfo.date }}
              </v-chip>
            </template>
          </v-tooltip>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>

    <div
      style="
        position: fixed;
        width: 450px;
        z-index: 10000;
        top: 10px;
        right: 10px;
      "
    >
      <v-alert
        v-for="(msg, i) in messages"
        :key="i"
        :type="msg.type"
        closable
      >
        {{ msg.message }}
      </v-alert>
    </div>
    <modal-merchant-select />
  </v-app>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useDisplay } from 'vuetify'
import { useAuthStore } from '@/stores/auth'
import { useAlertStore } from '@/stores/alert'
import { useMerchantStore } from '@/stores/merchant'
import ModalMerchantSelect from '@/components/merchant/ModalMerchantSelect.vue'
import SiteSearch from '@/components/SiteSearch.vue'
import getConfig from '@/utils.js'

const { t } = useI18n()
const route = useRoute()
const display = useDisplay()
const authStore = useAuthStore()
const alertStore = useAlertStore()
const merchantStore = useMerchantStore()

const drawer = ref(display.mdAndDown.value ? false : true)
const buildInfo = { commit: __GIT_COMMIT__, date: __BUILT_AT__.slice(0, 10), fullDate: __BUILT_AT__ }
const currentMerchImageLoadable = ref(true)
const appName = getConfig().appName

const user = computed(() => authStore.user)
const axiosBusy = computed(() => alertStore.axiosIsBusy)
const messages = computed(() => alertStore.messages)
const isAdmin = computed(() => authStore.isAdmin)
const isAgency = computed(() => authStore.isAgency)
const currentMerchant = computed(() => authStore.currentMerchant)
const merchantSearchType = computed(() => authStore.merchantSearchType)
const merchantLevel = computed(() => authStore.merchantLevel)

const menuItems = computed(() => {
  if (!user.value?.email) {
    return []
  }
  return [
    {
      icon: 'mdi-wallet-giftcard',
      key: 'campaigns',
      path_name: 'campaigns-list',
      path_params: { merchantIdent: currentMerchant?.value.uuid },
      items: [
        {
          icon: 'mdi-format-list-bulleted',
          key: 'campaigns_list',
          path_name: 'campaigns-list',
          path_params: { merchantIdent: currentMerchant?.value.uuid },
        },
        {
          icon: 'mdi-plus',
          key: 'campaigns_create',
          path_name: 'campaigns-create',
          path_params: { merchantIdent: currentMerchant?.value.uuid },
        },
      ],
    },
    {
      icon: 'mdi-store',
      key: 'merchant',
      items: [
        {
          icon: 'mdi-pencil',
          key: 'merchant_edit',
          path_name: 'merchant-edit',
          path_params: { merchantIdent: currentMerchant?.value.uuid },
        },
        {
          icon: 'mdi-account-group',
          key: 'merchant_accounts',
          path_name: 'merchant-accounts',
          path_params: { merchantIdent: currentMerchant?.value.uuid },
        },
        {
          icon: 'mdi-map-marker',
          key: 'merchant_locations',
          path_name: 'merchant-locations',
          path_params: { merchantIdent: currentMerchant?.value.uuid },
        },
      ],
    },
  ]
})

const currentMerchImageError = computed(() => {
  return currentMerchImageLoadable.value ? false : true
})

watch(currentMerchant, () => {
  currentMerchImageLoadable.value = true
})

const showMerchantSelectModal = () => {
  merchantStore.showMerchantSelectModal({
    show: true,
    closable: true,
  })
}

const ImageError = () => {
  currentMerchImageLoadable.value = false
}

const redirectAdmin = () => {
  window.location = 'https://admin.winxle.com'
}
</script>

<style>
code, kbd {
  background-color: rgba(198, 40, 40, 0.1);
  border-radius: 3px;
  color: #c62828;
  font-size: 0.875em;
  padding: 0.2em 0.4em;
}

pre {
  background-color: rgba(198, 40, 40, 0.08);
  border-radius: 4px;
  padding: 1em;
  overflow-x: auto;
}

pre code {
  background: none;
  padding: 0;
  color: inherit;
}
</style>
